import wizardStyle from "../../wizardStyle";

const administrativeDecisionFeedbackFormStyle = {
  ...wizardStyle,
  recommendation: {
    margin: "2rem 0",
    textAlign: "center",
    border: "1px solid",
    borderColor: "primary.main",
    borderRadius: "5px",
    padding: "0.5rem",
  },
  button: {
    margin: "1rem 0",
  },
};
export default administrativeDecisionFeedbackFormStyle;
